// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__JGQ_Z","legacyBtn":"MutateMid_legacyBtn__GfFRe"};